import * as React from 'react'

import { answerCellChangeHelper } from '../../utils/answerStateHelper'

function useAnswerCellState({
  isOfficeUseForm,
  response,
  setResponse,
  setAllDirty,
  setAnswerErrors,
  source,
}) {
  const [updatedCellQuestions, setUpdatedCellQuestions] = React.useState([])

  const onAnswerCellChange = React.useCallback(
    (question, rowData, columnData, value) => {
      const newUpdatedCellQuestions = answerCellChangeHelper({
        isOfficeUseForm,
        isOfficeUseQuestion: question.is_office_use_only,
        response,
        setResponse,
        question,
        rowData,
        columnData,
        value,
        setAllDirty,
        setAnswerErrors,
        updatedCellQuestions,
        source,
      })
      setUpdatedCellQuestions(newUpdatedCellQuestions)
    },
    [
      updatedCellQuestions,
      isOfficeUseForm,
      response,
      setAllDirty,
      setAnswerErrors,
      setResponse,
      source,
    ]
  )

  return [updatedCellQuestions, onAnswerCellChange]
}

export default useAnswerCellState
